<template>
  <div class="Inventory">

      <h1>Dev menu 0.1</h1>

<!--       <ul>
        <li v-for="items in inventory"> {{ items }}</li>
      </ul> -->
      
      <div class="columns">

        <div class="column">
          <h2>Progress</h2>
          <ul>
            <li> Slide: {{ this.$store.state.curSlide }}</li>
            <li> Quest: {{ this.$store.state.curQuest }}</li>
            <li> Checkpoint: {{ this.$store.state.checkPoint }}</li>

          </ul>
        </div>

        <div class="column">
          <h2>Properties</h2>
          <ul>
            <!-- <li v-for="props in hidden"> Hidden: {{ props }}</li> -->
            <li> Narrative: {{ this.$store.state.player.narrative }}</li>
            <li> Good: {{ this.$store.state.player.good }} | Evil: {{ this.$store.state.player.evil }} | Lol: {{ this.$store.state.player.lol }} </li>
            <li> Items: {{ this.$store.state.items }}</li>
            <li> Hidden: {{ this.$store.state.hidden }}</li>
          </ul>
        </div>

      </div>

      <div class="credits">
        <h2>Credits</h2>
        <a href="https://artrayd.com/" target="_blank">Dmitry Mind (story, design & code) - </a> 
        <a href="https://www.behance.net/olyaroz84d6e3" target="_blank">Olya Roz (design & love) - </a>
        <a href="https://codepen.io/yesasha/" target="_blank">yesasha (minigames code) </a><br>
        <span>Stanislav Kravez (characted design) - </span>
        <a href="http://shaytsukarel.blogspot.com/" target="_blank">Shay Tsurakel (character design)</a>
      </div>


      <div class="buttons">     
        <button @click="resset" class="reset"> Reset Game </button>
        <!-- <button @click="catLife" class="daemonToy">Meowniverse</button> -->
        <button @click="loadCheckpoint" class="checkpoint">Load Checkpoint </button>
        
      </div>

  </div>
</template>



<script>


export default {
  name: 'Inventory',
  data (){
    return {      
    }
  },

  mounted(){

    },

    methods: {
       resset(){
          this.$store.commit('reset')   
          location.reload()
      },

      loadCheckpoint(){
        if( this.$store.state.checkPoint != ''){
          this.$store.commit('checkTrue')  
        } else {
          alert("You don't have any saved progress, reset please")
        }
        
      },

      catLife(){
        this.$store.commit('changeNarrative', 'evil')
        this.$store.commit('saveCurSlide', '(meow-universe)start')
        setTimeout(function(){ location.reload() }, 10);
        
      }
    },



    created: function (){
    }
}

</script>